import { FlowStepHandleResult, HandleResultType, StepControl, AbstractStepController, StepControlType, WidgetComponent, WidgetCreationListener } from '@sdbn/common';
import { ContextChange } from '@sdbn/common';
import { RegisterEntranceComponent } from '../../components/visit-overview/dialog/register-entrance/component/register-entrance.component';
import { TerminalContextConstants } from '@sdbn/tmc-common';

export class RegisterEntranceController extends AbstractStepController implements WidgetCreationListener {

    registerEntranceComponent: RegisterEntranceComponent;

    onContextChange(contextChange: ContextChange) {
        if (contextChange.key === TerminalContextConstants.language) {

        }
    }

    onRegisterToDashboardContext() {

    }

    public handleFlow(): FlowStepHandleResult {
        const result = new FlowStepHandleResult();
        result.type = HandleResultType.DASHBOARD;
        return result;
    }

    getControls(): StepControl[] {
        const controls = new Array<StepControl>();

        const previousControl = new StepControl();
        previousControl.labelDictionaryKey = 'tmc-yard.common.action.cancel';
        previousControl.type = StepControlType.BUTTON_STROKED;
        previousControl.controlAction = () => {
            this.wizardComponent.endWizardFlow();
        };
        controls.push(previousControl);

        let spacer = new StepControl();
        spacer.type = StepControlType.SPACER_GROW;
        controls.push(spacer);

        const declineControl = new StepControl();
        declineControl.labelDictionaryKey = 'tmc-yard.ui.transport.register-entrance.action.decline';
        declineControl.type = StepControlType.BUTTON_STROKED;
        declineControl.controlAction = () => {
            console.error('not yet implemented!');
        };
        controls.push(declineControl);

        spacer = new StepControl();
        spacer.type = StepControlType.SPACER;
        controls.push(spacer);

        const confirmControl = new StepControl();
        confirmControl.labelDictionaryKey = 'tmc-yard.ui.transport.register-entrance.action.accept';
        confirmControl.type = StepControlType.BUTTON;
        confirmControl.controlAction = () => {
            this.registerEntranceComponent.accept().subscribe(
                response => {
                    this.wizardComponent.endWizardFlow();
                }, error => {
                    console.error(error);
                }
            );
        };
        controls.push(confirmControl);

        return controls;
    }

    widgetCreated(widgetIdentifier: string, widgetInstance: WidgetComponent) {

        const instance: any = widgetInstance;
        if (instance instanceof RegisterEntranceComponent) {
            this.registerEntranceComponent = instance;
        }
    }

}
